import styled from 'styled-components';
import { circleIconButton } from './CircleIconButton';
import { OnWhiteIconButton } from './OnWhiteIconButton';

/**
 * @deprecated replaced by `IconButton` in `@99designs/emu`
 */
export const OnWhiteCircleIconButton = styled(OnWhiteIconButton)(circleIconButton);
